module.exports = __webpack_public_path__ + "static/media/RecentlyViewed-4.63e0214b.png";